/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

const hiddenLimitLabels = new Set(["", "unlimited", "not included", "quota"]);

const normalizeLimitLabel = (value) => {
  const label = String(value ?? "").trim();
  if (hiddenLimitLabels.has(label.toLowerCase())) return null;
  return label || null;
};

const getLimitLabel = (feature) => {
  if (feature.limit_label || feature.limitLabel) {
    return normalizeLimitLabel(feature.limit_label ?? feature.limitLabel);
  }
  if (feature.limit_type === "unlimited") return null;
  if (feature.quota_value == null) return null;
  if (!feature.window) return normalizeLimitLabel(feature.quota_value);
  return normalizeLimitLabel(`${feature.quota_value} / ${feature.window}`);
};

export const normalizePlanFeature = (feature) => {
  return {
    code: feature.feature_code ?? feature.code ?? feature.feature,
    name: feature.name ?? feature.feature_name ?? feature.feature_code ?? "Feature",
    limitLabel: getLimitLabel(feature),
    displayOrder: feature.display_order ?? feature.displayOrder ?? 1000,
  };
};

export const getIncludedPlanFeatures = (tier) => {
  const legacyFeatures =
    tier.features
      ?.filter((feature) => feature.access === "on")
      .map((feature) => ({
        feature_code: feature.feature_code,
        name: feature.feature_name,
        limit_label: feature.limit_label,
        limit_type: feature.limit_type,
        quota_value: feature.quota_value,
        window: feature.window,
      })) ?? [];

  return (
    tier.plan_features ??
    tier.included_features ??
    tier.display_features?.filter((feature) => feature.included) ??
    legacyFeatures
  )
    .map(normalizePlanFeature)
    .sort((left, right) => {
      const orderDelta = left.displayOrder - right.displayOrder;
      if (orderDelta !== 0) return orderDelta;
      return left.name.localeCompare(right.name);
    });
};
